module.exports = __webpack_public_path__ + "img/how-pyn.de012c97.png";